import { resultsDuckCreator } from 'axl-ducks';
import { createSelector, DuckSelector } from '@atc/modular-redux';

// can we combine this w dealerlotduck
export default resultsDuckCreator({
    namespace: 'DEALERLOT',
    storePrefix: 'dealerLot',
    store: 'results',
}).extend({
    selectors: {
        fetchResults: (state) => state.dealerLotresults.activeResults,
        getInventory: (state) => state.inventory,
        fetchActiveInventoryResults: new DuckSelector((selectors) => createSelector(
            [selectors.fetchResults, (state) => state.inventory],
            (activeResults, inventory) => activeResults.map((item, index) => {
                const inventoryItem = inventory[item] || {};
                return {
                    ...inventoryItem,
                    isSaved: true,
                    c: inventoryItem.owner ? inventoryItem.owner.id : 'nl',
                    cmp: `dl_v_lstg_${index + 1}`,
                    v: inventoryItem.id,
                };

            })
        )),
    },
});
